<div class="row">
  @if (!file) {
    <div class="upload-wrapper col-lg-12">
      <input
        #fileInput
        [name]="name"
        id="{{ _id }}-input"
        class="file-input"
        type="file"
        accept="audio/*"
        (change)="fileChangeEvent($event)"
        placeholder="Choose a file..."
      />
      <label class="file-input-label" for="{{ _id }}-input" title="Choose a file...">
        <i class="material-icons">attach_file</i>
        Select, drag or paste file here
      </label>
      <div class="file-drop-area" appDroppable (dropped)="dropFile($event)">
        <div>Drop File Here</div>
      </div>
    </div>
  }

  @if (previewFileName) {
    <div class="preview-attachment col-lg-12">
      <div>
        {{ previewFileName }}
        <span (click)="removeAttachment()" class="remove-attachment" title="Remove attachment">
          <i class="material-icons">close</i>
        </span>
      </div>
      <div #previewContainer class="inner-container">
        <div style="display: inline-block; width: 100%; padding: 5px; background-color: transparent; height: 60px">
          <audio #audioPreview controls></audio>
        </div>
      </div>
    </div>
  }
</div>
